import { render, staticRenderFns } from "./AppApprovalsToolbar.vue?vue&type=template&id=0c5ceed8&scoped=true&"
import script from "./AppApprovalsToolbar.vue?vue&type=script&lang=js&"
export * from "./AppApprovalsToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5ceed8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
